module.exports = __webpack_public_path__ + "img/Matteo Guendouzi.e6cea87c.png";